import React from 'react'
import styles from './browser-modal.module.css'
import Modal from 'react-modal'
import { recommendedBrowser, downloadChrome} from '../../lib/xes/supported-browser';
import imgURL from './89a5687599f173f2b910aa5fcd862b42.svg';

class browserModal extends React.Component {
    constructor() {
        super();
        this.state = {
            showModal: !recommendedBrowser()
        }
        this.handleCloseModal = this.handleCloseModal.bind(this);
    }
    componentDidMount() {
        // 视频屏蔽右键功能
    }
    handleCloseModal() {
        this.setState({ showModal: false })
    }
    render() {
        return (
          // onRequestClose = { this.handleCloseModal }
          <Modal
            className={styles.modalContent}
            overlayClassName={styles.modalOverlay}
            isOpen={this.state.showModal}
            contentLabel="onRequestClose Example"
          >
            <div className={styles.root}>
              <a
                className={styles.btnClose}
                onClick={this.handleCloseModal}
                href="javascript:void(0)"
              />
              <div>
                <div className={styles.imgCover}>
                  <img src={imgURL} />
                </div>

                <h1 className={styles.text}>
                图形化编程不支持当前浏览器
                </h1>
                <h3>
                  十分抱歉，图形化编程并不支持你当前使用的浏览器或者当前版本
                </h3>
                <h3>我们建议使用最新版本的Chrome浏览器</h3>
                <a
                  className={styles.btnDownload}
                  onClick={downloadChrome}
                  href="javascript:void(0)"
                >
                  <h1>下载Chrome </h1>
                </a>
              </div>
            </div>
          </Modal>
        );
    }
}

export default browserModal




